import { withStyles } from '@material-ui/core/styles';
import NotificationModal from './NotificationModal';
import styles from './NotificationModal.styles';

export default withStyles(styles)(NotificationModal);
